import { createAction, createSlice } from "@reduxjs/toolkit";

// Types
import { Document } from "../../@types/document";
import { DocumentStakeholder } from "../../@types/documentStakeholder";
import { Message } from "../../@types/message";
import { fetchDocumentHistory } from "./actions/fetchDocumentHistory";
import { findDocument } from "./actions/findDocument";
import { findSigners } from "./actions/findSigners";

interface DocumentShowState {
  document: Document;
  signers: DocumentStakeholder[];
  history: Message[];
  segmentSelected: string;
  findStatus: string;
}

const initialState = {
  document: {},
  signers: [],
  history: [],
  segmentSelected: "info", //"signers"
  findStatus: "initial",
} as DocumentShowState;

export const setSegmentSelected = createAction<string>("SET_SEGMENT_SELECTED");

const documentSupervisorShowSlice = createSlice({
  name: "documentSupervisorShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setSegmentSelected, (state, { payload }) => {
        state.segmentSelected = payload;
      })
      .addCase(findDocument.pending, (state) => {
        state.findStatus = "pending";
        state.document = {};
        state.signers = [];
        state.segmentSelected = "info";
      })
      .addCase(findDocument.fulfilled, (state, { payload }) => {
        state.document = { ...payload };
        state.findStatus = "fulfilled";
      })
      .addCase(findDocument.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(findSigners.pending, (state) => {
        state.signers = [];
      })
      .addCase(findSigners.fulfilled, (state, { payload }) => {
        state.signers = payload;
      })
      .addCase(fetchDocumentHistory.pending, (state) => {
        state.history = [];
      })
      .addCase(fetchDocumentHistory.fulfilled, (state, { payload }) => {
        state.history = payload;
      });
  },
});

export const documentSupervisorShow = documentSupervisorShowSlice.reducer;
